var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntellijIdeaSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.7986577%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07B58",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577BAE",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7CE5",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.344827586%",
    y1: "34.5396825%",
    x2: "121.182266%",
    y2: "77.6190476%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB7A3E",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7B6A",
    offset: "15%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757B91",
    offset: "24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537BB1",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387CCC",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#237CE0",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147CEF",
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7CF7",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.1690141%",
    y1: "97.7493606%",
    x2: "30.1056338%",
    y2: "-6.62404092%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB417E",
    offset: "8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E4E9B",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755BB4",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5365CA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#386DDB",
    offset: "44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374E9",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1478F3",
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7BF8",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20%",
    y1: "24.0865385%",
    x2: "103.421589%",
    y2: "132.676282%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63462",
    offset: "4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3A71",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24383",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD4A91",
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755BB4",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D76ED",
    offset: "92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-1)",
    points: "64.8 199.6 2.8 150.8 33.6 93.6 122 128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-2)",
    points: "256 68.4 251.2 216.4 152.8 256 93.6 217.6 180 128 142.4 44.8 176.4 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-3)",
    points: "256 68.4 178 160.4 142.4 44.8 176.4 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-4)",
    points: "123.2 212.4 20.8 249.6 37.2 192 58.4 120.8 0 101.2 37.2 0 117.2 9.6 196.4 100"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 48,
    y: 48,
    width: 160,
    height: 160
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,178 L123.2,178 L123.2,188 L63.2,188 L63.2,178 Z M106,80.8 L106,68.8 L73.2,68.8 L73.2,80.8 L82.4,80.8 L82.4,122.8 L73.2,122.8 L73.2,135.2 L106,135.2 L106,122.8 L96.8,122.8 L96.8,80.8 L106,80.8 Z M138,136 C133.433351,136.205984 128.889763,135.242193 124.8,133.2 C121.453966,131.354025 118.472002,128.914237 116,126 L125.2,115.6 C126.861272,117.42513 128.742265,119.03741 130.8,120.4 C132.73613,121.535124 134.957474,122.09046 137.2,122 C139.666127,122.188479 142.064692,121.139107 143.6,119.2 C145.452667,116.813942 146.312461,113.804666 146,110.8 L146,68 L160.8,68 L160.8,111.2 C160.951789,114.737935 160.408195,118.271293 159.2,121.6 C158.144579,124.977032 156.212191,128.013641 153.6,130.4 C149.066749,133.765567 143.638763,135.714074 138,136 Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijIdeaSvgrepoCom);
export default __webpack_public_path__ + "static/media/intellij-idea-svgrepo-com.4eee2f3a1cfd9090a123401657834c3c.svg";
export { ForwardRef as ReactComponent };